import KathleenStern from '../images/kathleen_stern.jpg';
import '../scss/widgetarea.scss';

const WidgetArea = () => {
  return (
    <div className="user-account-dashboard-inner-wrapper">
      <div className="user-account-dashboard-widgets">
        <div className="dashboard-welcome-wrapper">
          <div className="dashboard-welcome-image">
            <img src={KathleenStern} alt=""></img>
          </div>
          <div className="dashboard-welcome-message">
            Hi Kathleen, welcome to your member dashboard! 😍 
          </div>
        </div>
        WIDGET AREA
      </div>
    </div>
  )
}

export default WidgetArea;